// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);
}

.hero-section {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
}

.hero-content {
  text-align: center;
  max-width: 800px;
  animation: fadeInUp 0.8s ease-out;
}

.hero-title {
  font-size: 2.25rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  margin-top: 0;
  color: #0f172a;
  line-height: 2.5rem;
}

.hero-subtitle {
  font-size: 1.25rem;
  font-weight: 400;
  color: #212529;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.btn-hero-primary {
  background-color: #28a745;
  color: #ffffff;
  border: none;
  padding: 1rem 2.5rem;
  border-radius: 0.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: background-color 0.3s ease;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.btn-hero-primary:hover {
  background-color: #218838;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);
}

.hero-note {
  font-size: 0.9rem;
  color: #212529;
  margin: 0;
}

.text-input-section {
  padding: 2rem 2rem 4rem;
  display: flex;
  justify-content: center;
}

.input-container {
  background-color: #ffffff;
  border-radius: 0.75rem;
  padding: 1rem;
  max-width: 900px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.input-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.input-label {
  font-size: 1.1rem;
  font-weight: 700;
  color: #212529;
}

.input-dropdown {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.4rem 1rem;
  border: 1px solid #e0e0e0;
  border-radius: 0.4rem;
  cursor: pointer;
  background-color: #fafafa;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.input-dropdown:hover {
  background-color: #f0f0f0;
}

.dropdown-label {
  font-weight: 500;
  color: #212529;
}

.dropdown-icon {
  font-size: 0.9rem;
}

.dropdown-arrow {
  color: #666666;
  font-size: 0.7rem;
}

.text-area {
  width: 90%;
  height: 120px;
  padding: 0.75rem;
  border: 1px solid #e0e0e0;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-family: inherit;
  resize: none;
  margin-bottom: 1.5rem;
  transition: border-color 0.3s ease;
  overflow-y: auto;
}

.text-area:focus {
  outline: none;
  border-color: #28a745;
  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);
}

.text-area::placeholder {
  color: #999999;
}

.input-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
}

.btn-paste {
  background-color: #ffffff;
  color: #28a745;
  border: 1px solid #28a745;
  padding: 0.5rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-paste:hover {
  background-color: #f0f0f0;
}

.word-count {
  font-size: 0.9rem;
  color: #999999;
}

.btn-humanize {
  background-color: #28a745;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-humanize:hover {
  background-color: #218838;
}

/* Features Section - Science & Precision */
.features-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
}

.feature-left {
  padding-right: 2rem;
}

.feature-title {
  font-size: 2rem;
  font-weight: 700;
  color: #000000 !important;
  margin-bottom: 1.5rem;
  line-height: 2.5rem;
}

.feature-description {
  font-size: 1.1rem;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 1rem;
}

.feature-right {
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-image-container {
  width: 100%;
  max-width: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-demo-image {
  width: 100%;
  max-width: 450px;
  height: auto;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.feature-demo-image:hover {
  transform: scale(1.02);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.placeholder-image {
  width: 100%;
  min-height: 300px;
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border: 2px dashed #66bb6a;
}

.placeholder-text {
  text-align: center;
  color: #2e7d32;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 2rem;
}

.placeholder-text small {
  font-size: 0.85rem;
  color: #388e3c;
  font-weight: 400;
  margin-top: 0.5rem;
  display: block;
}

/* AI Detectors Section */
.detectors-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 1rem;
}

.detectors-logos {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  padding: 2rem;
  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);
  border-radius: 1rem;
}

.detector-logo-card {
  background-color: #ffffff;
  padding: 1.5rem 1rem;
  border-radius: 0.75rem;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  color: #0f172a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: default;
}

.detector-logo-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.detectors-content {
  padding-left: 2rem;
}

.detectors-title {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.5rem;
  line-height: 2.5rem;
}

.detectors-description {
  font-size: 1.1rem;
  color: #475569;
  line-height: 1.8;
  margin-bottom: 1rem;
}

/* FAQ Section */
.faq-section {
  padding: 4rem 2rem;
  max-width: 800px;
  margin: 0 auto;
  background-color: transparent;
}

.faq-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 3rem;
}

.faq-container {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.faq-item {
  border-bottom: 1px solid #e2e8f0;
}

.faq-item:last-child {
  border-bottom: none;
}

.faq-question {
  width: 100%;
  padding: 1.5rem 0;
  background: none;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 500;
  color: #0f172a;
  text-align: left;
  transition: color 0.3s ease;
}

.faq-question:hover {
  color: #28a745;
}

.faq-question span:first-child {
  flex: 1 1;
  padding-right: 1rem;
}

.faq-icon {
  font-size: 0.8rem;
  color: #64748b;
  transition: transform 0.3s ease;
  display: inline-block;
}

.faq-icon.open {
  transform: rotate(180deg);
}

.faq-answer {
  padding: 0 0 1.5rem 0;
  font-size: 1rem;
  color: #475569;
  line-height: 1.7;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .hero-section {
    padding: 2rem 1rem;
  }

  .hero-title {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .btn-hero-primary {
    padding: 0.875rem 2rem;
    font-size: 1rem;
  }

  .input-container {
    padding: 0.75rem;
  }

  .input-label {
    font-size: 1rem;
  }

  .text-input-section {
    padding: 1rem 1rem 3rem;
  }

  /* Features Section Responsive */
  .features-section {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 3rem 1.5rem;
  }

  .feature-left {
    padding-right: 0;
    text-align: center;
  }

  .feature-title {
    font-size: 1.75rem;
    line-height: 2rem;
    color: #000000 !important;
  }

  .feature-description {
    font-size: 1rem;
  }

  .feature-image-container {
    max-width: 100%;
  }

  /* Detectors Section Responsive */
  .detectors-section {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 3rem 1.5rem;
  }

  .detectors-logos {
    order: 2;
  }

  .detectors-content {
    order: 1;
    padding-left: 0;
    text-align: center;
  }

  .detectors-title {
    font-size: 1.75rem;
    line-height: 2rem;
  }

  .detectors-description {
    font-size: 1rem;
  }

  /* FAQ Section Responsive */
  .faq-section {
    padding: 3rem 1.5rem;
  }

  .faq-title {
    font-size: 2rem;
  }

  .faq-question {
    font-size: 1rem;
    padding: 1.25rem 0;
  }

  .faq-answer {
    font-size: 0.95rem;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .btn-hero-primary {
    padding: 0.75rem 1.5rem;
    font-size: 0.95rem;
  }

  /* Features Section Small Mobile */
  .features-section {
    padding: 2rem 1rem;
  }

  .feature-title {
    font-size: 1.5rem;
    line-height: 1.75rem;
    color: #000000 !important;
  }

  .feature-description {
    font-size: 0.95rem;
  }

  .feature-demo-image {
    border-radius: 0.75rem;
  }

  /* Detectors Section Small Mobile */
  .detectors-section {
    padding: 2rem 1rem;
  }

  .detectors-title {
    font-size: 1.5rem;
    line-height: 1.75rem;
  }

  .detectors-description {
    font-size: 0.95rem;
  }

  .detector-logo-card {
    padding: 1rem 0.5rem;
    font-size: 0.875rem;
  }

  /* FAQ Section Small Mobile */
  .faq-section {
    padding: 2rem 1rem;
  }

  .faq-title {
    font-size: 1.75rem;
    margin-bottom: 2rem;
  }

  .faq-question {
    font-size: 0.95rem;
    padding: 1rem 0;
  }

  .faq-answer {
    font-size: 0.9rem;
    padding: 0 0 1rem 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/unAuth/LandingPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gEAAgE;AAClE;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA,gCAAgC;EAChC;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,0BAA0B;IAC1B,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA,2BAA2B;EAC3B;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA,kCAAkC;EAClC;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA,6BAA6B;EAC7B;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF","sourcesContent":[".landing-page {\n  min-height: 100vh;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to bottom, #e8f5e9 0%, #c8e6c9 100%);\n}\n\n.hero-section {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2rem;\n}\n\n.hero-content {\n  text-align: center;\n  max-width: 800px;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.hero-title {\n  font-size: 2.25rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  margin-top: 0;\n  color: #0f172a;\n  line-height: 2.5rem;\n}\n\n.hero-subtitle {\n  font-size: 1.25rem;\n  font-weight: 400;\n  color: #212529;\n  margin-bottom: 2rem;\n  line-height: 1.6;\n}\n\n.btn-hero-primary {\n  background-color: #28a745;\n  color: #ffffff;\n  border: none;\n  padding: 1rem 2.5rem;\n  border-radius: 0.5rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  transition: background-color 0.3s ease;\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\n}\n\n.btn-hero-primary:hover {\n  background-color: #218838;\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.4);\n}\n\n.hero-note {\n  font-size: 0.9rem;\n  color: #212529;\n  margin: 0;\n}\n\n.text-input-section {\n  padding: 2rem 2rem 4rem;\n  display: flex;\n  justify-content: center;\n}\n\n.input-container {\n  background-color: #ffffff;\n  border-radius: 0.75rem;\n  padding: 1rem;\n  max-width: 900px;\n  width: 100%;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.input-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.input-label {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #212529;\n}\n\n.input-dropdown {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.4rem 1rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 0.4rem;\n  cursor: pointer;\n  background-color: #fafafa;\n  font-size: 0.9rem;\n  transition: background-color 0.3s ease;\n}\n\n.input-dropdown:hover {\n  background-color: #f0f0f0;\n}\n\n.dropdown-label {\n  font-weight: 500;\n  color: #212529;\n}\n\n.dropdown-icon {\n  font-size: 0.9rem;\n}\n\n.dropdown-arrow {\n  color: #666666;\n  font-size: 0.7rem;\n}\n\n.text-area {\n  width: 90%;\n  height: 120px;\n  padding: 0.75rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n  resize: none;\n  margin-bottom: 1.5rem;\n  transition: border-color 0.3s ease;\n  overflow-y: auto;\n}\n\n.text-area:focus {\n  outline: none;\n  border-color: #28a745;\n  box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.1);\n}\n\n.text-area::placeholder {\n  color: #999999;\n}\n\n.input-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n}\n\n.btn-paste {\n  background-color: #ffffff;\n  color: #28a745;\n  border: 1px solid #28a745;\n  padding: 0.5rem 1.5rem;\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-paste:hover {\n  background-color: #f0f0f0;\n}\n\n.word-count {\n  font-size: 0.9rem;\n  color: #999999;\n}\n\n.btn-humanize {\n  background-color: #28a745;\n  color: #ffffff;\n  border: none;\n  padding: 0.5rem 1.5rem;\n  border-radius: 0.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-humanize:hover {\n  background-color: #218838;\n}\n\n/* Features Section - Science & Precision */\n.features-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  padding: 4rem 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  align-items: center;\n}\n\n.feature-left {\n  padding-right: 2rem;\n}\n\n.feature-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #000000 !important;\n  margin-bottom: 1.5rem;\n  line-height: 2.5rem;\n}\n\n.feature-description {\n  font-size: 1.1rem;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n.feature-right {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.feature-image-container {\n  width: 100%;\n  max-width: 450px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.feature-demo-image {\n  width: 100%;\n  max-width: 450px;\n  height: auto;\n  border-radius: 1rem;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.feature-demo-image:hover {\n  transform: scale(1.02);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);\n}\n\n.placeholder-image {\n  width: 100%;\n  min-height: 300px;\n  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border: 2px dashed #66bb6a;\n}\n\n.placeholder-text {\n  text-align: center;\n  color: #2e7d32;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 2rem;\n}\n\n.placeholder-text small {\n  font-size: 0.85rem;\n  color: #388e3c;\n  font-weight: 400;\n  margin-top: 0.5rem;\n  display: block;\n}\n\n/* AI Detectors Section */\n.detectors-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  padding: 4rem 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  align-items: center;\n  background-color: rgba(255, 255, 255, 0.5);\n  border-radius: 1rem;\n}\n\n.detectors-logos {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n  padding: 2rem;\n  background: linear-gradient(135deg, #c8e6c9 0%, #a5d6a7 100%);\n  border-radius: 1rem;\n}\n\n.detector-logo-card {\n  background-color: #ffffff;\n  padding: 1.5rem 1rem;\n  border-radius: 0.75rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 1rem;\n  color: #0f172a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  cursor: default;\n}\n\n.detector-logo-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);\n}\n\n.detectors-content {\n  padding-left: 2rem;\n}\n\n.detectors-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 1.5rem;\n  line-height: 2.5rem;\n}\n\n.detectors-description {\n  font-size: 1.1rem;\n  color: #475569;\n  line-height: 1.8;\n  margin-bottom: 1rem;\n}\n\n/* FAQ Section */\n.faq-section {\n  padding: 4rem 2rem;\n  max-width: 800px;\n  margin: 0 auto;\n  background-color: transparent;\n}\n\n.faq-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.faq-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.faq-item {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.faq-item:last-child {\n  border-bottom: none;\n}\n\n.faq-question {\n  width: 100%;\n  padding: 1.5rem 0;\n  background: none;\n  border: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #0f172a;\n  text-align: left;\n  transition: color 0.3s ease;\n}\n\n.faq-question:hover {\n  color: #28a745;\n}\n\n.faq-question span:first-child {\n  flex: 1;\n  padding-right: 1rem;\n}\n\n.faq-icon {\n  font-size: 0.8rem;\n  color: #64748b;\n  transition: transform 0.3s ease;\n  display: inline-block;\n}\n\n.faq-icon.open {\n  transform: rotate(180deg);\n}\n\n.faq-answer {\n  padding: 0 0 1.5rem 0;\n  font-size: 1rem;\n  color: #475569;\n  line-height: 1.7;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .hero-section {\n    padding: 2rem 1rem;\n  }\n\n  .hero-title {\n    font-size: 1.875rem;\n    line-height: 2.25rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1.1rem;\n  }\n\n  .btn-hero-primary {\n    padding: 0.875rem 2rem;\n    font-size: 1rem;\n  }\n\n  .input-container {\n    padding: 0.75rem;\n  }\n\n  .input-label {\n    font-size: 1rem;\n  }\n\n  .text-input-section {\n    padding: 1rem 1rem 3rem;\n  }\n\n  /* Features Section Responsive */\n  .features-section {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    padding: 3rem 1.5rem;\n  }\n\n  .feature-left {\n    padding-right: 0;\n    text-align: center;\n  }\n\n  .feature-title {\n    font-size: 1.75rem;\n    line-height: 2rem;\n    color: #000000 !important;\n  }\n\n  .feature-description {\n    font-size: 1rem;\n  }\n\n  .feature-image-container {\n    max-width: 100%;\n  }\n\n  /* Detectors Section Responsive */\n  .detectors-section {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n    padding: 3rem 1.5rem;\n  }\n\n  .detectors-logos {\n    order: 2;\n  }\n\n  .detectors-content {\n    order: 1;\n    padding-left: 0;\n    text-align: center;\n  }\n\n  .detectors-title {\n    font-size: 1.75rem;\n    line-height: 2rem;\n  }\n\n  .detectors-description {\n    font-size: 1rem;\n  }\n\n  /* FAQ Section Responsive */\n  .faq-section {\n    padding: 3rem 1.5rem;\n  }\n\n  .faq-title {\n    font-size: 2rem;\n  }\n\n  .faq-question {\n    font-size: 1rem;\n    padding: 1.25rem 0;\n  }\n\n  .faq-answer {\n    font-size: 0.95rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 1.5rem;\n    line-height: 2rem;\n  }\n\n  .hero-subtitle {\n    font-size: 1rem;\n  }\n\n  .btn-hero-primary {\n    padding: 0.75rem 1.5rem;\n    font-size: 0.95rem;\n  }\n\n  /* Features Section Small Mobile */\n  .features-section {\n    padding: 2rem 1rem;\n  }\n\n  .feature-title {\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n    color: #000000 !important;\n  }\n\n  .feature-description {\n    font-size: 0.95rem;\n  }\n\n  .feature-demo-image {\n    border-radius: 0.75rem;\n  }\n\n  /* Detectors Section Small Mobile */\n  .detectors-section {\n    padding: 2rem 1rem;\n  }\n\n  .detectors-title {\n    font-size: 1.5rem;\n    line-height: 1.75rem;\n  }\n\n  .detectors-description {\n    font-size: 0.95rem;\n  }\n\n  .detector-logo-card {\n    padding: 1rem 0.5rem;\n    font-size: 0.875rem;\n  }\n\n  /* FAQ Section Small Mobile */\n  .faq-section {\n    padding: 2rem 1rem;\n  }\n\n  .faq-title {\n    font-size: 1.75rem;\n    margin-bottom: 2rem;\n  }\n\n  .faq-question {\n    font-size: 0.95rem;\n    padding: 1rem 0;\n  }\n\n  .faq-answer {\n    font-size: 0.9rem;\n    padding: 0 0 1rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
